import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import Layout from "../../layouts/auth.vue";
Component.registerHooks(["metaInfo"]);
let AppLanding = /** @class */ (() => {
    let AppLanding = class AppLanding extends Vue {
        constructor() {
            super(...arguments);
            this.spinnerClass = false;
        }
        metaInfo() {
            return {
                title: "Login to Policy Plugin",
            };
        }
        signIn() {
            this.spinnerClass = !this.spinnerClass;
            localStorage.setItem("TenantGatewayRedirectRoute", this.$route.fullPath);
            this.$router.push({ name: "TenantGateway" });
        }
        userRegistration() {
            this.$router.push({ name: "UserRegistration" });
        }
    };
    AppLanding = __decorate([
        Component({
            name: "AppLanding",
            components: {
                Layout,
            },
        })
    ], AppLanding);
    return AppLanding;
})();
export default AppLanding;
